import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Link } from 'react-router-dom';
const FlexLink = styled(Link).withConfig({
  displayName: "TrackCardLink__FlexLink",
  componentId: "qige6m-0"
})(["flex-direction:column;height:100%;color:inherit;font:inherit;line-height:inherit;text-decoration:inherit;display:flex;-webkit-font-smoothing:auto;:hover{color:inherit;font:inherit;line-height:inherit;text-decoration:inherit;}"]);
const CardHolder = styled.div.withConfig({
  displayName: "TrackCardLink__CardHolder",
  componentId: "qige6m-1"
})(["display:flex;flex-direction:column;height:100%;"]);

const TrackCardLink = ({
  children,
  deprecated,
  to
}) => {
  if (deprecated || !to) {
    return /*#__PURE__*/_jsx(CardHolder, {
      children: children
    });
  }

  return /*#__PURE__*/_jsx(FlexLink, {
    to: to,
    children: children
  });
};

export default TrackCardLink;